import {
	Component,
	Input,
	Output,
	OnDestroy,
	OnChanges,
	EventEmitter
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { FileUploadServiceProvider } from '@services/files/file-upload-service/file-upload.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { ImageConverterProvider } from '@services/files/image-converter.service';

@Component({
	selector: 'attachments',
	template: require('./attachments.html')
})
export class AttachmentsComponent implements OnDestroy, OnChanges {
	@Input() filesObj: any;
	@Input() attachmentId: string;
	@Output() attachmentsChanged: EventEmitter<any> = new EventEmitter<any>();
	files: any = null;

	attachmentsView: Array<any> = [];
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private fileUploadService: FileUploadServiceProvider,
		private messageService: MessageService,
		private imageConverter: ImageConverterProvider
	) {}

	ngOnChanges() {
		if (this.filesObj !== undefined) {
			this.attachmentsView = this.filesObj.attachments;
			this.handleAttachmentsView(this.attachmentsView);
		}
	}

	ngOnDestroy() {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	renewFiles(event): void {
		if (event && event.target.files) {
			let newFile = event.target.files[0];
			newFile = this.fileUploadService.addFileConvertedSize(newFile);
			this.attachmentsView.push(newFile);
			this.handleAttachmentsView(this.attachmentsView, newFile);
		}
	}

	removeAttachment(index): void {
		this.attachmentsView.splice(index, 1);
		this.handleAttachmentsView(this.attachmentsView);
	}

	private handleAttachmentsView(attachmentsView, newFile?): void {
		if (attachmentsView && attachmentsView.length > 0) {
			const resultSize = this.fileUploadService.getTotalSize(attachmentsView);
			const maxSize: number = this.fileUploadService.maxAttachment;

			if (resultSize > maxSize) {
				this.messageService.showToaster('w_0', 'attachments');
				if (typeof newFile !== 'undefined') {
					attachmentsView.pop(newFile);
					return;
				}
			}

			if (this.filesObj === undefined) {
				this.filesObj = {};
			}
		}
		this.buildFileObj();
		this.attachmentsChanged.emit(this.filesObj);
	}

	buildFileObj() {
		if (this.attachmentsView !== undefined || this.attachmentsView !== null) {
			const max = this.attachmentsView.length;
			let size = 0;

			for (let i = 0; i < max; i++) {
				const fileSize =
					this.attachmentsView[i].size || this.attachmentsView[i].bytesSize;
				size += fileSize;
			}
			size /= 1024 * 1000;
			size = Number(size.toFixed(2));

			this.filesObj.filesSize = size;
			this.attachmentsView.forEach(value => {
				value.convertedType = this.imageConverter.getFileClass(value.name);

				if (value.bytesSize) {
					value.convertedSize = (
						parseInt(value.bytesSize) /
						(1024 * 1024)
					).toFixed(2); // convert from bytes to MB
				} else {
					value.convertedSize = (parseInt(value.size) / (1024 * 1024)).toFixed(
						2
					); // convert from bytes to MB
				}
			});

			this.filesObj.attachments = this.attachmentsView;
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./mobile/src/components/files/attachments/attachments.ts